import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatSmileLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M27.7931 12.8877C32.0919 12.8877 35.5782 16.3741 35.5782 20.6728V34.3406C35.5782 38.6417 32.0919 42.1276 27.7931 42.1276H25.6798C24.5488 42.1278 23.4646 42.5752 22.6641 43.3756L19.8555 46.1862C18.7143 47.327 16.864 47.3271 15.7227 46.1862L12.9141 43.3756C12.1137 42.5752 11.0295 42.1278 9.89847 42.1276H7.78713C3.48593 42.1276 0 38.6417 0 34.3406V20.6728C0 16.3741 3.48593 12.8877 7.78713 12.8877H27.7931Z",
			fill: "url(#paint0_linear_22773_28137)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M44.9043 24.5703V10.9004C44.9043 7.2095 41.9143 4.2207 38.2227 4.2207H18.2168C14.5061 4.2207 11.5176 7.21108 11.5176 10.9004L11.4941 11.1211C11.3916 11.6197 10.9508 11.9941 10.4219 11.9941C9.8173 11.9941 9.32667 11.5048 9.32617 10.9004C9.32617 5.99724 13.3004 2.0293 18.2168 2.0293H38.2227C43.1231 2.0293 47.0957 5.99882 47.0957 10.9004V24.5703C47.0957 29.4877 43.1247 33.459 38.2227 33.459H38.1113C37.5069 33.4585 37.0176 32.9678 37.0176 32.3633C37.0176 31.7587 37.5069 31.2681 38.1113 31.2676H38.2227C41.9127 31.2676 44.9043 28.2803 44.9043 24.5703Z",
			fill: "black",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3323 29.4447C11.8979 29.2309 12.5284 29.5158 12.7424 30.0814C13.5122 32.1151 15.4785 33.5577 17.7776 33.5579C20.0774 33.5579 22.0429 32.115 22.8127 30.0814C23.0268 29.5157 23.6591 29.2307 24.2248 29.4447C24.7904 29.6586 25.0752 30.2892 24.8616 30.8548C23.7802 33.7129 21.018 35.7474 17.7776 35.7474C14.5381 35.7471 11.7769 33.7126 10.6955 30.8548C10.4818 30.2892 10.7667 29.6587 11.3323 29.4447Z",
			fill: "#3B3EE4"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_22773_28137",
			x1: 2.67164,
			y1: 15.1334,
			x2: 26.9108,
			y2: 51.7209,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#6366F1",
				stopOpacity: .4
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6366F1"
			})]
		}) })
	]
});
export default SvgChatSmileLight;
